"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _dialog = require("@package/dialog");

var _reactDom = _interopRequireDefault(require("react-dom"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _slice = require("../ducks/slice");

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultsModule = _interopRequireDefault(require("./defaults.module.scss"));

var PRIMARY_MODE = 'primary';
var INFO_MODE = 'info';
var WARNING_MODE = 'warning';
var DANGER_MODE = 'danger';
var SUCCESS_MODE = 'success';

function Dialog(_ref) {
  var _cn;

  var _data = _ref._data,
      className = _ref.className,
      title = _ref.title,
      mode = _ref.mode,
      name = _ref.name,
      children = _ref.children,
      onClose = _ref.onClose,
      align = _ref.align;
  var dispatch = (0, _reactRedux.useDispatch)();
  var wrapperRef = (0, _react.useRef)(null);
  var data = (0, _reactRedux.useSelector)(_slice.selectData);
  var isOpen = (0, _reactRedux.useSelector)(_slice.selectIsOpen);
  var actionDialogName = (0, _reactRedux.useSelector)(_slice.selectName);

  function handleCloseDialog() {
    dispatch((0, _dialog.closeDialog)(name));
    onClose && onClose(name);
  }

  function handleOutClick(event) {
    var wrapperElement = wrapperRef.current;
    var target = event.target;

    if (wrapperElement === target) {
      handleCloseDialog();
    }
  }

  (0, _react.useEffect)(function () {
    return function () {
      dispatch((0, _dialog.resetStateAction)());
    };
  }, []);
  var classNameCloseDialog = (0, _classnames["default"])(_defaultsModule["default"]['dialog__close'], 'icon-close');
  var classNameDialog = (0, _classnames["default"])(_defaultsModule["default"]['dialog'], className, (_cn = {}, (0, _defineProperty2["default"])(_cn, _defaultsModule["default"]['dialog--primary'], mode === PRIMARY_MODE), (0, _defineProperty2["default"])(_cn, _defaultsModule["default"]['dialog--success'], mode === SUCCESS_MODE), (0, _defineProperty2["default"])(_cn, _defaultsModule["default"]['dialog--info'], mode === INFO_MODE), (0, _defineProperty2["default"])(_cn, _defaultsModule["default"]['dialog--danger'], mode === DANGER_MODE), (0, _defineProperty2["default"])(_cn, _defaultsModule["default"]['dialog--warning'], mode === WARNING_MODE), _cn));
  var classNameContent = (0, _classnames["default"])(_defaultsModule["default"]['wrapper__content'], (0, _defineProperty2["default"])({}, _defaultsModule["default"]['wrapper__content--align_top'], align === 'top'));
  return isOpen && name === actionDialogName && /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultsModule["default"]['wrapper'],
    "data-locator": _data ? "".concat(_data, ".wrapper") : 'wrapper'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: wrapperRef,
    className: classNameContent,
    onClick: handleOutClick
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classNameDialog,
    "data-locator": _data ? "".concat(_data, ".dialog") : 'dialog'
  }, /*#__PURE__*/_react["default"].createElement("span", {
    "data-locator": _data ? "".concat(_data, ".close") : 'close',
    className: classNameCloseDialog,
    onClick: handleCloseDialog
  }), title && /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultsModule["default"]['dialog__header'],
    "data-locator": _data ? "".concat(_data, ".header") : 'header'
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: _defaultsModule["default"]['dialog__title'],
    "data-locator": _data ? "".concat(_data, ".title") : 'title'
  }, title)), /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultsModule["default"]['dialog__content'],
    "data-locator": _data ? "".concat(_data, ".content") : 'content'
  }, /*#__PURE__*/_react["default"].cloneElement(children, {
    data: data
  }))))), document.querySelector('#dialog'));
}

Dialog.defaultProps = {
  _data: '',
  className: null,
  data: null,
  name: null,
  title: null,
  mode: 'default',
  align: 'default',
  isOpen: false
};
var _default = Dialog;
exports["default"] = _default;